(angular => {
  "use strict";

  angular.module("App").factory("activityListFactory", [
    "$filter",
    "dateHelper",
    "$sce",
    AuthServiceInterceptor
  ]);

  function AuthServiceInterceptor($filter, dateHelper, $sce) {
    return function(activities) {
      if (!activities.length) return [];
      return grouByDate(mapData(activities));
    };

    function mapData(activities) {
      return activities.map(activity => {
        activity.speakers = activity.speakers.map(s => s.speaker);
        activity.speakers.sort(function(a, b) {
          let textA = a.name.toUpperCase();
          let textB = b.name.toUpperCase();
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      });
        activity.description = $sce.trustAsHtml(activity.description);
        return activity;
      });
    }

    function grouByDate(activities) {
      const dateFilter = $filter("date");

      const isSameDay = (date1, date2) => {
        const date1Formatted = dateFilter(date1, "yyyy-MM-dd");
        const date2Formatted = dateFilter(date2, "yyyy-MM-dd");

        return date1Formatted === date2Formatted;
      };

      const groups = activities.reduce((acc, activityDate) => {
        let group = acc[acc.length - 1];

        if (group.length === 0) {
          group.push(activityDate);
          return acc;
        }

        const last = group[group.length - 1];
        if (isSameDay(activityDate.date, last.date)) {
          group.push(activityDate);
          return acc;
        }

        group = [activityDate];
        acc.push(group);
        return acc;
      }, [
        []
      ]);
      for(const g of groups){
        g.sort((a,b) => {
            return (a.start_time + a.place) > (b.start_time + b.place) ? 1 : -1;
        });
      }
      return groups;
    }
  }

})(angular);
